import type { TFunction } from 'i18next';

import type { ActiveFilterChip } from '@/features/header-filters';
import { formatDisplayDate } from '@/shared/lib';

import type { DispatchInProgressUrlState } from './types';

interface BuildDispatchInProgressFilterChipsArgs {
  state: DispatchInProgressUrlState;
  t: TFunction;
  onRemove: (key: string) => void;
}

/**
 * Removable active-filter chips for the committed in-progress dispatch state
 * (search excluded — it lives in the header search box). The dispatch-date
 * range is one chip; removing it clears both bounds.
 */
export function buildDispatchInProgressFilterChips({
  state,
  onRemove
}: BuildDispatchInProgressFilterChipsArgs): ActiveFilterChip[] {
  const chips: ActiveFilterChip[] = [];

  if (state.consignmentNumber) {
    chips.push({
      key: 'consignmentNumber',
      label: state.consignmentNumber,
      onRemove: () => onRemove('consignmentNumber')
    });
  }

  if (state.dateFrom || state.dateTo) {
    const label = [
      state.dateFrom ? formatDisplayDate(state.dateFrom) : null,
      state.dateTo ? formatDisplayDate(state.dateTo) : null
    ]
      .filter(Boolean)
      .join(' – ');

    chips.push({ key: 'date', label, onRemove: () => onRemove('date') });
  }

  return chips;
}
